<template>
  <v-card :color="dark" outlined tile>
    <v-card-text>
      <v-list-item>
        <v-list-item-icon>
          <v-btn fab x-small color="grey">
            {{ review.customer_id }}
          </v-btn>
        </v-list-item-icon>

        <v-list-item-content class="ml-n4">
          <v-list-item-title
            >Customer {{ review.customer_id }}
            <span class="text-caption font-weight-light">
              {{ review.created_at }}</span
            >
          </v-list-item-title>
        </v-list-item-content>

        <span> {{ review.rating }}</span>
        <v-list-item-action class="ml-n1">
          <v-rating
            v-model="review.rating"
            half-increments
            background-color="orange lighten-3"
            color="orange"
            class=""
            readonly
            size="15"
          ></v-rating>
        </v-list-item-action>
      </v-list-item>

      <span style="white-space: pre-line" class="ml-4" v-html="review.review"> </span>

      <span class="ml-4 text--disabled">
        {{ review.assignment_type }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import colorMxn from "@/mixins/colorMxn";

export default {
  name: "reviewComponent",
  mixins: [colorMxn],
  props: ["review"],
  data() {
    return {};
  }
};
</script>
